import * as React from "react";
import { useHistory } from "react-router";
import { UserContext, isInRole } from "../../../contexts/UserContext";
import { MENUETTPORTALKOMMUN_BOENDESAMORDNARE, MENUETTPORTALKOMMUN_KOMMUNALADMINISTRATÖR, MENUETTPORTALKOMMUN_PRIVATANSVARIG, MENUETTPORTALMA, MENUETTPORTALVA } from "../../../utils/RoleConstants";
import { CLINIC, MUNICIPALITY, ORGANISATION } from "../../../utils/RouteConstants";

export const Home: React.FunctionComponent<{}> = () => {
    const userInfo = React.useContext(UserContext);
    const history = useHistory();
    const hasRoleVA = isInRole(MENUETTPORTALVA, userInfo.roles ? userInfo.roles : []);
    const hasRoleMA = isInRole(MENUETTPORTALMA, userInfo.roles ? userInfo.roles : []);
    const hasRoleBoendesamordnare = isInRole(MENUETTPORTALKOMMUN_BOENDESAMORDNARE, userInfo.roles ? userInfo.roles : []);
    const hasRoleKommunalAdministratör = isInRole(MENUETTPORTALKOMMUN_KOMMUNALADMINISTRATÖR, userInfo.roles ? userInfo.roles : []);
    const hasRolePrivatAnsvarig = isInRole(MENUETTPORTALKOMMUN_PRIVATANSVARIG, userInfo.roles ? userInfo.roles : []);
    
    React.useEffect(() => {
        if (hasRoleVA) {
            history.push(`/${ORGANISATION}/${userInfo.organisationId}`);
        } else if (hasRoleMA) {
            history.push(`/${CLINIC}/${userInfo.clinicId}`);
        } else if (hasRoleBoendesamordnare || hasRoleKommunalAdministratör || hasRolePrivatAnsvarig) {
            history.push(`/${MUNICIPALITY}`);
        }
    }, []);

    return (
        <>
        </>
    );
}